module.exports = "https://cdn.hellotech.com/client-assets/peace-of-mind_7be34957380ae5bddb3b13b503a6b935.jpg";